import { useLocalStorage } from 'usehooks-ts';

import { UseMutationResult } from 'react-query';
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from '../constants/config.ts';
import useFastRequest from './requests/useFastRequest.ts';
import AuthAPI from '../api/services/auth';
import { useChatClient } from '../providers/ChatClientProvider';
import { QueryKeys } from '../api/query.keys.ts';
import Routes from '../router/routes.enum.ts';

const useLogout = (onlyClearLocalStorage?: boolean): [() => void, UseMutationResult<any>] => {
  const [, setAccessToken] = useLocalStorage<string | null>(ACCESS_TOKEN_KEY, null);
  const [refreshToken, setRefreshToken] = useLocalStorage<string | null>(REFRESH_TOKEN_KEY, null);
  const { disconnectChat } = useChatClient();
  const clearTokens = () => {
    // Disconnect from Stream Chat first
    disconnectChat();
    setAccessToken(null);
    setRefreshToken(null);
  };

  const [logout, state] = useFastRequest(
    () => {
      AuthAPI.signOut({
        refreshToken: refreshToken || '',
      });
      window.location.href = Routes.SignIn;
    },
    {
      ignoreErrors: ['Unauthorized'],
      invalidateArgs: [QueryKeys.Me, QueryKeys.AgencyMe],
      onSuccess: clearTokens,
      onError: clearTokens,
    },
  );

  const handleLogout = () => {
    if (onlyClearLocalStorage) {
      clearTokens();
      return;
    }

    logout();
  };

  return [handleLogout, state];
};

export default useLogout;
